module.exports = __webpack_public_path__ + "static/media/2-en.3c926d7a.svg";